/* bsb-product-img.js — swipeable hero carousel, synced to variant selection.
   Swiping checks the matching radio input and dispatches `change` (reusing
   the existing variant-matching logic in bsb-product-info.js). Selecting a
   swatch elsewhere moves every initialized carousel instance to the
   matching slide — keeps the desktop and mobile copies in sync even though
   only one is visible at a time. */

(function () {
  'use strict';

  if (typeof Swiper === 'undefined') return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const instances = [];

  function initOne(el) {
    if (el.dataset.bsbPiInitialized) return;
    el.dataset.bsbPiInitialized = 'true';

    const inputName = el.dataset.inputName;
    if (!inputName) return;

    const slides = Array.from(el.querySelectorAll('.bsb-pi__ball-slide'));
    const paginationEl = el.querySelector('.swiper-pagination');
    const prevEl = el.querySelector('.bsb-pi__ball-arrow--prev');
    const nextEl = el.querySelector('.bsb-pi__ball-arrow--next');

    const checkedInput = document.querySelector('input[name="' + inputName + '"]:checked');
    const initialSlide = checkedInput
      ? slides.findIndex(function (s) {
          return s.getAttribute('data-option-value') === checkedInput.value;
        })
      : -1;

    const swiper = new Swiper(el, {
      slidesPerView: 1,
      threshold: 5,
      slideToClickedSlide: false,
      speed: reducedMotion ? 0 : 450,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      initialSlide: initialSlide !== -1 ? initialSlide : 0,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
        disabledClass: 'bsb-pi__ball-arrow--disabled',
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous',
        nextSlideMessage: 'Next',
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      on: {
        slideChange: function (sw) {
          const slide = slides[sw.activeIndex];
          if (!slide) return;
          const value = slide.getAttribute('data-option-value');
          const input = document.querySelector(
            'input[name="' + inputName + '"][value="' + CSS.escape(value) + '"]'
          );
          if (input && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        },
      },
    });

    instances.push({ swiper: swiper, inputName: inputName, slides: slides });

    el.addEventListener('click', function (e) {
      if (!e.target.closest('.bsb-pi__ball-img')) return;
      if (swiper.allowClick === false) return;
      openHeroLightbox(slides, swiper.activeIndex, e.target.closest('.bsb-pi__swiper'));
    });
  }

  function slideImages(slides) {
    return slides
      .map(function (slide) {
        const img = slide.querySelector('img');
        if (!img) return null;
        return { src: img.currentSrc || img.src, alt: img.alt || '' };
      })
      .filter(Boolean);
  }

  function openHeroLightbox(slides, index, triggerEl) {
    if (typeof window.bsbOpenLightbox !== 'function') return;
    const items = slideImages(slides);
    if (!items.length) return;
    window.bsbOpenLightbox(Math.min(index, items.length - 1), items, triggerEl);
  }

  function init() {
    document.querySelectorAll('.bsb-pi__swiper').forEach(initOne);
  }

  document.addEventListener('click', function (e) {
    const img = e.target.closest('.bsb-pi__ball-img');
    if (!img || img.closest('.bsb-pi__swiper')) return;
    openHeroLightbox([img.parentElement || img], 0, img);
  });

  document.addEventListener('bsb:configurator-refreshed', function () {
    for (let i = instances.length - 1; i >= 0; i--) {
      const inst = instances[i];
      if (!inst.swiper.el || !inst.swiper.el.isConnected) {
        try {
          inst.swiper.destroy(true, true);
        } catch (err) {}
        instances.splice(i, 1);
      }
    }
    init();
  });

  document.addEventListener('change', function (e) {
    const name = e.target.name;
    if (!name) return;
    instances.forEach(function (inst) {
      if (inst.inputName !== name) return;
      const idx = inst.slides.findIndex(function (s) {
        return s.getAttribute('data-option-value') === e.target.value;
      });
      if (idx !== -1 && inst.swiper.activeIndex !== idx) {
        inst.swiper.slideTo(idx);
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  'use strict';

  const dataEl = document.getElementById('bsb-product-data');
  if (!dataEl) return;

  let scaleId = null;
  try {
    const data = JSON.parse(dataEl.textContent);
    const current = (data.variants || []).find((v) => v.id === data.currentVariantId);
    scaleId = current && current.scaleId ? String(current.scaleId) : null;
  } catch (err) {
    return;
  }

  let open = false;
  let opened = false;
  let startX = null;

  function setKeyboard(enabled) {
    document.querySelectorAll('.bsb-pi__swiper').forEach((el) => {
      if (!el.swiper || !el.swiper.keyboard) return;
      if (enabled) el.swiper.keyboard.enable();
      else el.swiper.keyboard.disable();
    });
  }

  function render() {
    if (!scaleId) open = false;
    document.querySelectorAll('.bsb-pi__scale-toggle').forEach((btn) => {
      const ball = btn.closest('.bsb-pi__ball');
      const label = btn.querySelector('.bsb-pi__scale-label');
      btn.hidden = !scaleId;
      btn.classList.toggle('bsb-pi__scale-toggle--open', open);
      if (label) label.textContent = open ? btn.dataset.closeLabel : btn.dataset.label;
      if (!ball) return;
      ball.querySelectorAll('.bsb-pi__scale-media').forEach((media) => {
        media.hidden = !(opened && media.dataset.scaleId === scaleId);
      });
      ball.classList.toggle('bsb-pi__ball--scale', open);
    });
    setKeyboard(!open);
  }

  function setOpen(next) {
    if (next && !scaleId) return;
    if (next) opened = true;
    open = next;
    render();
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('.bsb-pi__scale-toggle')) setOpen(!open);
  });

  document.addEventListener('keydown', (e) => {
    if (!open) return;
    if (e.key === 'Escape') {
      setOpen(false);
      return;
    }
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    if (e.target === document.body || e.target.closest('.bsb-pi__ball')) setOpen(false);
  });

  document.addEventListener('pointerdown', (e) => {
    startX = open && e.target.closest('.bsb-pi__scale') ? e.clientX : null;
  });

  document.addEventListener('pointerup', (e) => {
    if (startX === null) return;
    const dx = e.clientX - startX;
    startX = null;
    if (Math.abs(dx) > 30) setOpen(false);
  });

  document.addEventListener('bsb:variant-change', (e) => {
    const variant = e.detail && e.detail.variant;
    scaleId = variant && variant.scaleId ? String(variant.scaleId) : null;
    render();
  });

  document.addEventListener('bsb:configurator-refreshed', render);
})();
